module.exports = __webpack_public_path__ + "img/close_icon.6029b0f7.png";